export default __webpack_public_path__ + "static/media/mada.3da16ee2.png";